import type { SxProps, Theme } from '@mui/material';

export const covConstantsStyles = {
  docInfo: {
    minWidth: 0,
    maxWidth: 340,
  } as SxProps<Theme>,
  tablePrimaryText: {
    color: 'text.primary',
    fontFamily: '"Nunito Sans", sans-serif',
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 400,
    letterSpacing: 0,
  } as SxProps<Theme>,
  tablePrimaryTextMultiLine: {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  } as SxProps<Theme>,
  tablePrimaryTextSingleLine: {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
  } as SxProps<Theme>,
  periodText: {
    color: 'text.secondary',
    fontSize: '0.9375rem',
    lineHeight: '22px',
    fontWeight: 400,
  } as SxProps<Theme>,
  tableDateText: {
    color: 'text.primary',
    fontFamily: '"Nunito Sans", sans-serif',
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 400,
    letterSpacing: 0,
  } as SxProps<Theme>,
  deadlineText: (isPastDeadline: boolean) => (theme: Theme) => ({
    color: isPastDeadline ? theme.palette.error.main : theme.palette.text.secondary,
    fontSize: '0.9375rem',
    lineHeight: '22px',
    fontWeight: 400,
    whiteSpace: 'nowrap',
  }),
  covBtn: (theme: Theme) => ({
    minHeight: 36,
    padding: '8px 16px',
    borderRadius: '100px',
    borderColor: theme.palette.border.subtle,
    color: theme.palette.text.primary,
    fontSize: '0.875rem',
    lineHeight: '20px',
    fontWeight: 500,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    boxShadow: 'none',
    '&:hover': {
      borderColor: theme.palette.border.subtle,
      backgroundColor: theme.palette.primary['200'],
      color: theme.palette.text.primary,
      boxShadow: 'none',
    },
    '& .MuiButton-endIcon': {
      color: 'inherit',
    },
  }),
  statusChip: (theme: Theme) => ({
    minWidth: 89,
    height: 27,
    borderRadius: '100px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
    '& .MuiChip-label': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      fontSize: '14px',
      lineHeight: '19px',
      fontWeight: 500,
    },
    '&.MuiChip-colorDefault': {
      backgroundColor: `${theme.palette.primary['200']} !important`,
      color: theme.palette.primary.main,
    },
    '&.MuiChip-colorPrimary': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: theme.palette.common.white,
    },
    '&.MuiChip-colorInfo': {
      backgroundColor: `${theme.palette.info.main} !important`,
      color: theme.palette.common.white,
    },
    '&.MuiChip-colorSuccess': {
      backgroundColor: `${theme.palette.covenantStatus.success} !important`,
      color: theme.palette.common.white,
    },
    '&.MuiChip-colorError': {
      backgroundColor: `${theme.palette.covenantStatus.error} !important`,
      color: theme.palette.common.white,
    },
    '&.MuiChip-colorWarning': {
      backgroundColor: `${theme.palette.covenantStatus.warning} !important`,
      color: theme.palette.common.white,
    },
  }),
  processingStatusChip: (theme: Theme) => ({
    '&.MuiChip-colorDefault': {
      backgroundColor: `${theme.palette.primary['200']} !important`,
      color: theme.palette.primary.main,
    },
  }),
} as const;


